import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/digital-print',
    name: 'DigitalPrint',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/digital-print/trend-material/list',
    meta: {
      title: '数码印花',
    },
    children: [

      {
        path: 'pattern-library/list',
        name: 'InspirationCenterPatternLibraryList',
        component: () => import('@/modules/inspiration-center/pattern-library/views/list/index.vue'),
        meta: {
          title: '图案库',
          auth: true,
        },
      },
      {
        path: 'pattern-library/task-list',
        name: 'InspirationCenterPatternLibraryTaskList',
        component: () => import('@/modules/inspiration-center/pattern-library/views/task-list/index.vue'),
        meta: {
          title: '图案设计任务',
          auth: true,
        },
      },
      {
        path: 'pattern-library/task-detail/:id',
        name: 'InspirationCenterPatternLibraryTaskDetail',
        component: () => import('@/modules/inspiration-center/pattern-library/views/task-detail/index.vue'),
        meta: {
          title: '图案设计任务详情',
          auth: true,
          activeMenu: 'InspirationCenterPatternLibraryTaskList'
        },
      },
      {
        path: 'pattern-library/create-task',
        name: 'InspirationCenterPatternLibraryCreateTask',
        component: () => import('@/modules/inspiration-center/pattern-library/views/create-task/index.vue'),
        meta: {
          title: '图案设计',
          auth: true,
        },
      },
      {
        path: 'select-style/list',
        name: 'InspirationCenterSelectStyleList',
        component: () => import('@/modules/inspiration-center/select-style/views/list/index.vue'),
        meta: {
          title: '选款列表',
          auth: true,
        },
      },
      {
        path: 'select-style/detail/:id',
        name: 'InspirationCenterSelectStyleDetail',
        component: () => import('@/modules/inspiration-center/select-style/views/detail/index.vue'),
        meta: {
          title: '选款详情',
          auth: false,
          activeMenu: 'InspirationCenterSelectStyleList'
        }
      },

      {
        path: 'logo-manager/create',
        name: 'InspirationCenterLogoManagerCreate',
        component: () => import('@/modules/inspiration-center/pattern-manager/views/create-or-edit/index.vue'),
        meta: {
          title: '款式贴图',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'logo-manager/edit/:detailId/:taskDetailId',
        name: 'InspirationCenterLogoManagerEdit',
        component: () => import('@/modules/inspiration-center/pattern-manager/views/create-or-edit/index.vue'),
        meta: {
          title: '款式贴图',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterLogoManagerCreate'
        },
      },
      {
        path: 'logo-manager/history',
        name: 'InspirationCenterLogoManagerHistory',
        component: () => import('@/modules/inspiration-center/pattern-manager/views/history/index.vue'),
        meta: {
          title: '生成记录',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterLogoManagerCreate'
        },
      },
      {
        path: 'logo-manager/list',
        name: 'InspirationCenterLogoManagerList',
        component: () => import('@/modules/inspiration-center/pattern-manager/views/list/index.vue'),
        meta: {
          title: '款式贴图任务',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterLogoManagerList'
        },
      },
      {
        path: 'logo-manager/detail/:id',
        name: 'InspirationCenterLogoManagerDetail',
        component: () => import('@/modules/inspiration-center/pattern-manager/views/detail/index.vue'),
        meta: {
          title: '款式贴图详情',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'InspirationCenterLogoManagerList'
        },
      },
      {
        path: 'trend-material/list',
        name: 'DigitalPrintTrendMaterialList',
        component: () => import('./trend-material/views/list/index.vue'),
        meta: {
          title: '趋势素材',
          auth: true,
        },
      },
      {
        path: 'production-picture/list',
        name: 'DigitalPrintProductionPictureList',
        component: () => import('./production-picture/views/list/index.vue'),
        meta: {
          title: '生产图列表',
          auth: true,
        },
      },
      {
        path: 'texture-batch-task/list',
        name: 'InspirationCenterTextureBatchTaskList',
        component: () => import('./texture-batch-task/views/list/index.vue'),
        meta: {
          title: '贴图批次任务',
          auth: true,
        },
      },
      {
        path: 'ai-material/list',
        name: 'DigitalPrintAIMaterialList',
        component: () => import('./ai-material/views/list.vue'),
        meta: {
          title: 'ai素材',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'ai-material/create',
        name: 'DigitalPrintAIMaterialCreate',
        component: () => import('./ai-material/views/create.vue'),
        meta: {
          title: '创建ai素材',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintAIMaterialList'
        },
      },
      {
        path: 'ai-material/detail/:taskId',
        name: 'DigitalPrintAIMaterialDetail',
        component: () => import('./ai-material/views/detail/index.vue'),
        meta: {
          title: 'ai素材详情',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintAIMaterialList'
        },
      },
      {
        path: 'dress-up/list',
        name: 'DigitalPrintDressUpList',
        component: () => import('./dress-up/views/list.vue'),
        meta: {
          title: '服装上身',
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'dress-up/create',
        name: 'DigitalPrintDressUpCreate',
        component: () => import('./dress-up/views/create.vue'),
        meta: {
          title: '服装上身',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintDressUpList'
        },
      },
      {
        path: 'dress-up/detail/:taskId',
        name: 'DigitalPrintDressUpDetail',
        component: () => import('./dress-up/views/detail/index.vue'),
        meta: {
          title: '服装上身',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintDressUpList'
        },
      },
      {
        path: 'dress-up-template/list',
        name: 'DigitalPrintDressUpTemplateList',
        component: () => import('./dress-up-template/views/list/index.vue'),
        meta: {
          title: '版型耗材库',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintDressUpTemplateList'
        }
      },
      {
        path: 'logo-workbench/create',
        name: 'DigitalPrintLogoWorkbenchCreate',
        component: () => import('./logo-workbench/views/create/index.vue'),
        meta: {
          title: '贴图工作台',
          auth: true,
        },
      },
      {
        path: 'pattern-consumables-diagram/list',
        name: 'DigitalPrintPatternConsumablesDiagramList',
        component: () => import('./pattern-consumables-diagram/views/list/index.vue'),
        meta: {
          title: '图案耗材图',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintPatternConsumablesDiagramList'
        },
      },
      {
        path: 'pattern-consumables-diagram/create',
        name: 'DigitalPrintPatternConsumablesDiagramCreate',
        component: () => import('./pattern-consumables-diagram/views/create/index.vue'),
        meta: {
          title: '图案耗材图',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintPatternConsumablesDiagramList'
        },
      },
      {
        path: 'ai-cropping/list',
        name: 'DigitalPrintAICroppingList',
        component: () => import('./ai-cropping/views/list/index.vue'),
        meta: {
          title: 'AI裁剪',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintAICroppingList'
        },
      },
      {
        path: 'automated-digital-print/list',
        name: 'DigitalPrintAutomatedDigitalPrintList',
        component: () => import('./automated-digital-print/views/list/index.vue'),
        meta: {
          title: '自动化贴图',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintAutomatedDigitalPrintList'
        },
      },
      {
        path: 'automated-digital-print/create',
        name: 'DigitalPrintAutomatedDigitalPrintCreate',
        component: () => import('./automated-digital-print/views/create/index.vue'),
        meta: {
          title: '自动化贴图',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintAutomatedDigitalPrintList'
        },
      },
      {
        path: 'ai-region-recognition/list',
        name: 'DigitalPrintAIRegionRecognitionList',
        component: () => import('./ai-region-recognition/views/list/index.vue'),
        meta: {
          title: 'AI区域识别任务',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPrintAIRegionRecognitionList'
        },
      },
      {
        path: 'selection-list/list',
        name: 'DigitalSelectionList',
        component: () => import('./selection-list/views/list/index.vue'),
        meta: {
          title: '选款列表',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalSelectionList'
        },
      },
      {
        path: 'full-print-selection-list/list',
        name: 'DigitalFullPrintSelectionList',
        component: () => import('./selection-list/views/list/index.vue'),
        meta: {
          title: '满印选款',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalFullPrintSelectionList'
        },
      },
      {
        path: 'pod-style-tasks/list',
        name: 'DigitalPodStyleTasksList',
        component: () => import('./pod-style-tasks/views/list/index.vue'),
        meta: {
          auth: true,
          isKeepAlive: false,
        },
      },
      {
        path: 'pod-style-tasks/create',
        name: 'DigitalPodStyleTasksCreate',
        component: () => import('./pod-style-tasks/views/create/index.vue'),
        meta: {
          title: 'POD任务创建',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPodStyleTasksList'
        },
      },
      {
        path: 'pod-style-tasks/copy/:id',
        name: 'DigitalPodStyleTasksCopy',
        component: () => import('./pod-style-tasks/views/create/index.vue'), 
        meta: {
          title: 'POD任务复制',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPodStyleTasksList'
        },
      },
      {
        path: 'pod-style-tasks/view/:id',
        name: 'DigitalPodStyleTasksView',
        component: () => import('./pod-style-tasks/views/view/index.vue'),
        meta: {
          title: 'POD任务查看',
          auth: true,
          isKeepAlive: false,
          activeMenu: 'DigitalPodStyleTasksList'
        },
      }
    ],
  },
] as IRouteConfig[];
